

const DateUtils = {
    getDay(timestamp) {
        const date = new Date(timestamp * 1000);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },

    getDayCode(dayStr) {
        if (!dayStr.includes('.')) return dayStr.trim().toLowerCase();
        const [code] = dayStr.split('.');
        return code.trim().toLowerCase();
    },

    getDayLabel(code) {
        if (!code) return code;
        const trimmed = code.trim();
        return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
    },

    formatDayOnly(dayStr, t) {
        if (!dayStr.includes('.')) return dayStr;

        const [dayCodeRaw, dayNumRaw] = dayStr.split('.');
        const dayCodeTrimmed = dayCodeRaw.trim();
        const dayLabel = dayCodeTrimmed.charAt(0).toUpperCase() + dayCodeTrimmed.slice(1).toLowerCase();
        let dayNumber = (dayNumRaw || '1').trim();

        // Next year check if Dec 31
        const now = new Date();
        const isDec31 = now.getDate() === 31 && now.getMonth() === 11;
        let suffix = '';
        if (isDec31 && dayNumber === '1') {
            suffix = ' (next year)';
        }

        return `${dayLabel} ${dayNumber}${suffix}`;
    },
}

export default DateUtils;